import useSessionStorage from "./useSessionStorage";

function useAppKey() {
  const [appKey, setAppKey] = useSessionStorage("appKey");
  const params = new URLSearchParams(window.location.search);
  const newAppKey = params.has("appKey") ? params.get("appKey") : null;
  if (newAppKey && newAppKey !== appKey) {
    setAppKey(newAppKey);
    return newAppKey;
  }
  return appKey;
}

export default useAppKey;
